import { render, staticRenderFns } from "./S3CephXsky.vue?vue&type=template&id=5572fe7b&"
import script from "./S3CephXsky.vue?vue&type=script&lang=js&"
export * from "./S3CephXsky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports